import { render, staticRenderFns } from "./GoodsBackList.vue?vue&type=template&id=32adcc34"
import script from "./GoodsBackList.vue?vue&type=script&lang=js"
export * from "./GoodsBackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports